/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type AIJobStatus =
  | "queued"
  | "transcribing"
  | "generating_minutes"
  | "complete";

export type AISummarizationLevel = "none" | "medium" | "high";

export type MotionCategory =
  | "subsidiary"
  | "incidental"
  | "recital"
  | "privileged";

export type MeetingTypeOptionType = "checkbox" | "select";

export type FieldLayoutConditionOperator =
  | "&&"
  | "||"
  | "!"
  | "=="
  | "!="
  | ">"
  | "<"
  | ">="
  | "<=";

export type FieldType =
  | "text"
  | "text-area"
  | "radio-group"
  | "select"
  | "optional-select"
  | "checkbox"
  | "date-picker"
  | "password"
  | "approver"
  | "presenter"
  | "multiple-checkboxes";

export type LegislationNumberType = "bill" | "ordinance" | "resolution";

export type LaserfichePushType =
  | "agendas"
  | "documents"
  | "minutes"
  | "signed"
  | "orphanSigned";

export type NumberFormat =
  | "none"
  | "decimal"
  | "roman"
  | "lowerRoman"
  | "alpha"
  | "lowerAlpha"
  | "bullet"
  | "bulletOpen"
  | "squareBullet"
  | "squareBulletOpen";

export type LegislationNumberingFormat = "number" | "yearNumber";

export type MinutesOrdering = "timestamps" | "agenda";

export type OldNumberFormat =
  | "decimal"
  | "roman"
  | "lowerRoman"
  | "alpha"
  | "lowerAlpha";

export type AttendeeStatus = "present" | "absent" | "phone";

export type AgendaItemPositionType = "afterItem" | "atSectionStart";

export type ApproverType = "team" | "user" | "none";

export type DocumentApprovalType =
  | "proclamations"
  | "resolutions"
  | "ordinances"
  | "agreements"
  | "iga"
  | "report"
  | "plan"
  | "appointment";

export type SubmitterStatus =
  | "pending"
  | "sent"
  | "opened"
  | "completed"
  | "declined"
  | "skipped";

export type SubmissionStatus =
  | "draft"
  | "sent"
  | "declined"
  | "completed"
  | "archived";

export type SourceType = "client" | "server";

export type VoteAnswer = "yes" | "no" | "abstain";

export type VoteType = "voice" | "hand" | "rollcall" | "ballot";

export type ReviewStatus = "rejected" | "pending" | "approved" | "deferred";

export type ResolutionStatus = "proposed" | "passed" | "failed";

export type OrdinanceStatus = "proposed" | "passed" | "failed";

export type UploadTypeId =
  | "administrative-records"
  | "personnel-records"
  | "tax-records"
  | "legal-records"
  | "elections-records"
  | "court-records"
  | "property-records"
  | "meeting-minutes"
  | "meeting-agenda"
  | "ordinances"
  | "resolutions"
  | "zoning-planning-records"
  | "newspaper-clipping"
  | "reference-document";

export type AttachmentType = "editable" | "original" | "signed";

export type StatusType = "draft" | "private" | "public";

export type Duration = "forever" | "once" | "repeating";

export type StripeSubscriptionStatus =
  | "active"
  | "canceled"
  | "incomplete"
  | "incomplete_expired"
  | "past_due"
  | "paused"
  | "trialing"
  | "unpaid";

export type StripeCheckoutSessionStatus = "complete" | "expired" | "open";

export type TeamMemberClass = "voting" | "active" | "support";

export type RoleType = "none" | "admin" | "edit" | "view" | "submit";

/** Construct a type with a set of properties K of type T */
export type RecordStringString = Record<string, string>;

export interface DecodedIdToken {
  uid: string;
  sub: string;
  picture?: string;
  phone_number?: string;
  iss: string;
  /** @format double */
  iat: number;
  firebase: {
    tenant?: string;
    second_factor_identifier?: string;
    sign_in_second_factor?: string;
    sign_in_provider: string;
  };
  /** @format double */
  exp: number;
  email_verified?: boolean;
  email?: string;
  /** @format double */
  auth_time: number;
  aud: string;
}

/** @format date-time */
export type DateType = Date;

export interface PublicUser {
  salutation: string;
  lastName: string;
  firstName: string;
  updatedBy: string;
  updatedAt: DateType;
  createdBy: string;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

export interface PublicTenant {
  publishedAt?: DateType;
  timeZone?: string;
  /** @format double */
  organizationMunicipalityPopulation?: number;
  organizationMunicipalityName?: string;
  organizationMunicipalityId?: string;
  organizationMunicipalityTypeId?: string;
  organizationMunicipalityType?: string;
  organizationState?: string;
  organizationSize?: string;
  organizationType?: string;
  name: string;
  friendlyId: string;
  updatedBy: string;
  updatedAt: DateType;
  createdBy: string;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

export interface Address {
  country: string;
  zip: string;
  state: string;
  city: string;
  street2: string;
  street: string;
  type: string;
}

export interface PublicTeamMember {
  expirationDate?: DateType;
  expires?: boolean;
  class?: TeamMemberClass;
  role: RoleType;
  userId: string;
  title: string;
}

export interface PublicTeam {
  publishedAt?: DateType;
  defaultLetterHeadId?: string;
  defaultTemplateId?: string;
  teamMembers: PublicTeamMember[];
  address?: Address;
  name: string;
  updatedBy: string;
  updatedAt: DateType;
  createdBy: string;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

export interface Municipality {
  /** @format double */
  population: number;
  name: string;
  type: string;
  /** @format double */
  typeId: number;
  county: string;
  /** @format double */
  countyId: number;
  state: string;
  /** @format double */
  stateId: number;
  /** @format double */
  id: number;
}

export interface Pagination {
  /** @format double */
  prevPage: number | null;
  /** @format double */
  nextPage: number | null;
  /** @format double */
  limit: number;
  /** @format double */
  totalPages: number;
  /** @format double */
  page: number;
  /** @format double */
  total: number;
}

export interface Coupon {
  valid: boolean;
  /** @format double */
  duration_in_months: number | null;
  applies_to?: {
    products: string[];
  };
  duration: Duration;
  name: string | null;
  /** @format double */
  percent_off: number | null;
  /** @format double */
  amount_off: number | null;
  object: string;
  id: string;
}

export interface PromotionCode {
  coupon: Coupon;
  code: string;
  id: string;
}

export interface SiteColors {
  info: string;
  warning: string;
  error: string;
  success: string;
  tertiary: string;
  secondary: string;
  primary: string;
}

export interface PublicSite {
  colorScheme: SiteColors;
  banner: string;
  logo: string;
  updatedBy: string;
  updatedAt: DateType;
  createdBy: string;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

export interface Tag {
  text: string;
  id: string;
}

export interface PhoneNumber {
  number: string;
  type: string;
}

export interface ContactInfo {
  primaryPhone: PhoneNumber | PhoneNumber[];
  primaryAddress: Address;
  salutation: string;
  email: string;
  lastName: string;
  firstName: string;
}

export interface PublicTeamMemberWContact {
  contactInfo: ContactInfo;
  expirationDate?: DateType;
  expires?: boolean;
  class?: TeamMemberClass;
  role: RoleType;
  userId: string;
  title: string;
}

export interface PublicLetterHead {
  members: PublicTeamMemberWContact[];
  logoUrl: string;
  phoneNumber: string;
  website?: string;
  email: string;
  name: string;
  viewName?: string;
  updatedBy: string;
  updatedAt: DateType;
  createdBy: string;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

export interface Attachment {
  attachmentId: string;
  /** @format double */
  sizeBytes?: number;
  extension?: string;
  mimeType?: string;
  path: string;
  url: string;
  name: string;
  isUrl?: boolean;
  attachmentType: AttachmentType;
}

export interface OrdinanceData {
  status?: OrdinanceStatus;
  category?: string;
  draftNumber?: string;
  number?: string;
}

export interface ResolutionData {
  status?: ResolutionStatus;
  number?: string;
}

export interface DocumentMinutesData {
  official?: boolean;
  /** @format double */
  revision?: number;
  meetingId?: string;
}

export interface DocumentAgendaData {
  official?: boolean;
  meetingId?: string;
}

export interface PublicDocument {
  publishedAt?: DateType;
  agendaData?: DocumentAgendaData;
  minutesData?: DocumentMinutesData;
  resolutionData?: ResolutionData;
  ordinanceData?: OrdinanceData;
  uploadType?: UploadTypeId;
  visibleOnAgenda?: boolean;
  confidentialReason?: string | string[];
  confidential?: boolean;
  teamId?: string;
  attachments: Attachment[];
  description: string;
  name: string;
  updatedBy: string;
  updatedAt: DateType;
  createdBy: string;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

export interface AgendaItemUserVote {
  reason?: string;
  vote: VoteAnswer;
  userId: string;
}

export interface AgendaItemVotes {
  users?: AgendaItemUserVote[];
  /** @format double */
  abstain: number;
  /** @format double */
  no: number;
  /** @format double */
  yes: number;
  type: VoteType;
}

export interface Submitter {
  lastStatusChange?: DateType;
  status: SubmitterStatus;
  role?: string;
  name?: string;
  email: string;
  /** @format double */
  id: number;
}

export interface Submission {
  submitters?: Submitter[];
  status: SubmissionStatus;
  createdAt: string;
  /** @format double */
  id: number;
}

export interface SubmitterTemplate {
  email?: string | null;
  name: string;
  uuid: string;
}

export interface SubmissionTemplate {
  submitters?: SubmitterTemplate[];
  submissions?: Submission[];
  expirationDate?: DateType;
  originalAttachmentOutdated?: boolean;
  userId: string;
  status: SubmissionStatus;
  slug: string;
  /** @format double */
  id: number;
}

export interface Document {
  submissionTemplate?: SubmissionTemplate | null;
  publishedAt?: DateType;
  agendaData?: DocumentAgendaData;
  minutesData?: DocumentMinutesData;
  resolutionData?: ResolutionData;
  ordinanceData?: OrdinanceData;
  uploadType?: UploadTypeId;
  visibleOnAgenda?: boolean;
  confidentialReason?: string | string[];
  confidential?: boolean;
  teamId?: string;
  parentIds?: string[];
  attachments: Attachment[];
  linkedAttachment?: string;
  description: string;
  name: string;
  tags?: Tag[];
  status: StatusType;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface AgendaItemReview {
  motions?: AgendaItemMotion[];
  votes?: AgendaItemVotes;
  seconded?: string;
  moved?: string;
  comments?: string;
  status?: ReviewStatus;
  reviewedBy?: string;
  originalMotion?: string;
  /** @format double */
  timestampEnd?: number;
  /** @format double */
  timestamp?: number;
  meetingId?: string;
}

export interface Approver {
  approverId: string;
  approverType?: ApproverType;
}

export interface Presenter {
  manualEntry?: string;
  userId?: string;
}

export interface AgendaItemPosition {
  positionId: string;
  positionType: AgendaItemPositionType;
}

export interface AgendaItemTemplate {
  position?: AgendaItemPosition;
  createdAgendaItemId?: string;
  partialAgendaItem?: {
    glAccount?: string;
    expirationNotification?: string[];
    expirationDate?: DateType;
    expires?: boolean;
    motion?: string;
    script?: string;
    comment?: string;
    presenter?: Presenter | string;
    approver?: Approver;
    software?: boolean;
    lease?: boolean;
    docapprovaltype?: DocumentApprovalType;
    term?: string;
    annualPrice?: string;
    price?: string;
    requestedApprovalDate?: DateType;
    biddingThresholds?: string;
    biddingRequired?: boolean;
    emergencyOverride?: boolean;
    prevailingWage?: boolean;
    stateApprovedPricing?: boolean;
    why?: string;
    vendor?: string;
    newVersionOfTheItemId?: string;
    publishedAt?: DateType;
    review?: AgendaItemReview | null;
    teamId?: string;
    parentIds?: string[];
    documents?: Document[] | null;
    documentIds?: string[];
    type?: string;
    submittedBy?: string;
    body?: string;
    description?: string;
    name?: string;
    templateId?: string;
    template?: boolean;
    tags?: Tag[];
    status?: StatusType;
    updatedBy?: string;
    createdBy?: string;
    updatedAt?: DateType;
    createdAt?: DateType;
    id?: string;
    _source?: SourceType;
    /** @format double */
    _schemaVersion?: number;
    _preserveVersion?: boolean;
    /** @format double */
    _version?: number;
    _deleted?: boolean;
  };
}

export interface AgendaItemMotion {
  nesting?: AgendaItemMotion[];
  agendaItemTemplate?: AgendaItemTemplate;
  resolved?: boolean;
  status?: ReviewStatus;
  votes?: AgendaItemVotes;
  amendment?: string;
  comments?: string;
  debate?: string;
  seconded?: string;
  moved?: string;
  /** @format double */
  timestampEnd?: number;
  /** @format double */
  timestamp: number;
  motionId: string;
}

export interface PublicAgendaItem {
  glAccount?: string;
  expirationNotification?: string[];
  expirationDate?: DateType;
  expires?: boolean;
  motion?: string;
  script?: string;
  comment?: string;
  presenter?: Presenter | string;
  approver?: Approver;
  software?: boolean;
  lease?: boolean;
  docapprovaltype?: DocumentApprovalType;
  term?: string;
  annualPrice?: string;
  price?: string;
  requestedApprovalDate?: DateType;
  biddingThresholds?: string;
  biddingRequired?: boolean;
  emergencyOverride?: boolean;
  prevailingWage?: boolean;
  stateApprovedPricing?: boolean;
  why?: string;
  vendor?: string;
  publishedAt?: DateType;
  review?: AgendaItemReview | null;
  teamId?: string;
  documents: PublicDocument[] | null;
  documentIds: string[];
  type: string;
  submittedBy: string;
  body: string;
  description: string;
  name: string;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

export interface PublicAgendaModule {
  publishedAt?: DateType;
  teamId?: string;
  agendaItems: PublicAgendaItem[] | null;
  agendaItemIds: string[];
  type: string;
  body: string;
  description: string;
  name: string;
  updatedBy: string;
  updatedAt: DateType;
  createdBy: string;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

export interface PublicAgenda {
  publishedAt?: DateType;
  teamId?: string;
  agendaModules: PublicAgendaModule[] | null;
  agendaModuleIds: string[];
  letterHead: PublicLetterHead | null;
  letterHeadId?: string | null;
  downloadUrl?: string;
  description: string;
  name: string;
  tags?: Tag[];
  status: StatusType;
  updatedBy: string;
  updatedAt: DateType;
  createdBy: string;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringNumber = Record<string, number>;

export interface Attendee {
  status: AttendeeStatus;
  userId: string;
}

export interface MeetingReview {
  motions?: AgendaItemMotion[];
  attendees?: Attendee[];
  chairman?: string;
  secretary?: string;
  startTime?: DateType;
  /** Construct a type with a set of properties K of type T */
  itemVersions?: RecordStringNumber;
}

export interface MeetingMinutesData {
  /** @format double */
  latestRevision?: number;
  documentId?: string;
  json: string;
}

export interface PublicMeeting {
  publishedAt: DateType | null;
  agendaPublishedAt?: DateType;
  agendaPdfFilePath?: string;
  agendaPdfFileName?: string;
  agendaUrl?: string;
  meetingTypeOption?: string | string[];
  meetingType?: string;
  teamId?: string;
  letterHead: PublicLetterHead | null;
  letterHeadId?: string | null;
  minutesData?: MeetingMinutesData | null;
  review?: MeetingReview;
  address?: Address;
  agenda: PublicAgenda | null;
  agendaId: string;
  endTime: DateType;
  startTime: DateType;
  description: string;
  name: string;
  updatedBy: string;
  updatedAt: DateType;
  createdBy: string;
  createdAt: DateType;
  id: string;
  /** @format double */
  _version: number;
}

export interface AppConfig {
  sitesUrl: string;
  apiUrl: string;
  adminUrl: string;
  environment: string;
  connected: boolean;
}

export interface User {
  /** @format double */
  termsAndConditionsAcceptedVersion?: number;
  termsAndConditionsAcceptedAt?: DateType;
  termsAndConditionsAccepted?: boolean;
  stripeCustomerId?: string;
  subscriptionStatus?: string;
  subscriptionId?: string;
  superAdmin?: boolean;
  lastLoginTime?: DateType;
  image?: string | null;
  emailVerified?: boolean | null;
  primaryPhone: PhoneNumber | PhoneNumber[];
  primaryAddress: Address;
  salutation: string;
  email: string;
  lastName: string;
  firstName: string;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface PatchUserDto {
  /** @format double */
  termsAndConditionsAcceptedVersion?: number;
  termsAndConditionsAcceptedAt?: DateType;
  termsAndConditionsAccepted?: boolean;
  stripeCustomerId?: string;
  subscriptionStatus?: string;
  subscriptionId?: string;
  superAdmin?: boolean;
  lastLoginTime?: DateType;
  image?: string | null;
  emailVerified?: boolean | null;
  primaryPhone?: PhoneNumber | PhoneNumber[];
  primaryAddress?: Address;
  salutation?: string;
  email?: string;
  lastName?: string;
  firstName?: string;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface LegislationNumberCounter {
  /** @format double */
  number: number;
  /** @format double */
  year?: number;
}

export interface FeatureFlags {
  aiMeetingMinutes?: boolean;
  laserfiche?: boolean;
  signatures?: boolean;
}

export interface Tenant {
  featureFlags?: FeatureFlags;
  publishedAt?: DateType;
  lastResolutionNumber?: LegislationNumberCounter;
  resolutionNumberingFormat?: LegislationNumberingFormat;
  lastOrdinanceNumber?: LegislationNumberCounter;
  lastBillNumber?: LegislationNumberCounter;
  billNumberingFormat?: LegislationNumberingFormat;
  ordinanceNumberingFormat?: LegislationNumberingFormat;
  minutesOrdering?: MinutesOrdering;
  numberFormat?: OldNumberFormat;
  standardTags?: Tag[];
  timeZone?: string;
  /** @format double */
  organizationMunicipalityPopulation?: number;
  organizationMunicipalityName?: string;
  organizationMunicipalityId?: string;
  organizationMunicipalityTypeId?: string;
  organizationMunicipalityType?: string;
  organizationState?: string;
  organizationSize?: string;
  organizationType?: string;
  /** @format double */
  ownerTermsAndConditionsAcceptedVersion?: number;
  ownerTermsAndConditionsAcceptedAt?: DateType;
  ownerTermsAndConditionsAccepted?: boolean;
  ownerStripeCustomerId?: string;
  subscriptionStatus?: string;
  subscriptionId?: string;
  noneUsers?: string[];
  submitUsers: string[];
  viewUsers: string[];
  editUsers: string[];
  adminUsers: string[];
  ownerId: string;
  name: string;
  friendlyId: string;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface UserWRole {
  role: RoleType;
  /** @format double */
  termsAndConditionsAcceptedVersion?: number;
  termsAndConditionsAcceptedAt?: DateType;
  termsAndConditionsAccepted?: boolean;
  stripeCustomerId?: string;
  subscriptionStatus?: string;
  subscriptionId?: string;
  superAdmin?: boolean;
  lastLoginTime?: DateType;
  image?: string | null;
  emailVerified?: boolean | null;
  primaryPhone: PhoneNumber | PhoneNumber[];
  primaryAddress: Address;
  salutation: string;
  email: string;
  lastName: string;
  firstName: string;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface PatchTenantDto {
  featureFlags?: FeatureFlags;
  publishedAt?: DateType;
  lastResolutionNumber?: LegislationNumberCounter;
  resolutionNumberingFormat?: LegislationNumberingFormat;
  lastOrdinanceNumber?: LegislationNumberCounter;
  lastBillNumber?: LegislationNumberCounter;
  billNumberingFormat?: LegislationNumberingFormat;
  ordinanceNumberingFormat?: LegislationNumberingFormat;
  minutesOrdering?: MinutesOrdering;
  numberFormat?: OldNumberFormat;
  standardTags?: Tag[];
  timeZone?: string;
  /** @format double */
  organizationMunicipalityPopulation?: number;
  organizationMunicipalityName?: string;
  organizationMunicipalityId?: string;
  organizationMunicipalityTypeId?: string;
  organizationMunicipalityType?: string;
  organizationState?: string;
  organizationSize?: string;
  organizationType?: string;
  /** @format double */
  ownerTermsAndConditionsAcceptedVersion?: number;
  ownerTermsAndConditionsAcceptedAt?: DateType;
  ownerTermsAndConditionsAccepted?: boolean;
  ownerStripeCustomerId?: string;
  subscriptionStatus?: string;
  subscriptionId?: string;
  noneUsers?: string[];
  submitUsers?: string[];
  viewUsers?: string[];
  editUsers?: string[];
  adminUsers?: string[];
  ownerId?: string;
  name?: string;
  friendlyId?: string;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface TeamMember {
  includeInLetterhead?: boolean;
  expirationNotification?: string[];
  expirationDate?: DateType;
  expires?: boolean;
  notifications?: {
    meetingPublished?: boolean;
  };
  class?: TeamMemberClass;
  role: RoleType;
  userId: string;
  title: string;
}

export interface Time {
  /** @format double */
  minutes: number;
  /** @format double */
  hours: number;
}

export interface Team {
  publishedAt?: DateType;
  defaultEndTime?: Time;
  defaultStartTime?: Time;
  defaultLetterHeadId?: string;
  defaultTemplateId?: string;
  teamMembers: TeamMember[];
  allUsers: string[];
  noneUsers?: string[];
  submitUsers: string[];
  viewUsers: string[];
  editUsers: string[];
  adminUsers: string[];
  address?: Address;
  name: string;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export type CreateTeamDto = {
  publishedAt?: DateType;
  defaultEndTime?: Time;
  defaultStartTime?: Time;
  defaultLetterHeadId?: string;
  defaultTemplateId?: string;
  teamMembers?: TeamMember[];
  allUsers?: string[];
  noneUsers?: string[];
  submitUsers?: string[];
  viewUsers?: string[];
  editUsers?: string[];
  adminUsers?: string[];
  address?: Address;
  name?: string;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
} & {
  name: string;
};

export interface PatchTeamDto {
  publishedAt?: DateType;
  defaultEndTime?: Time;
  defaultStartTime?: Time;
  defaultLetterHeadId?: string;
  defaultTemplateId?: string;
  teamMembers?: TeamMember[];
  allUsers?: string[];
  noneUsers?: string[];
  submitUsers?: string[];
  viewUsers?: string[];
  editUsers?: string[];
  adminUsers?: string[];
  address?: Address;
  name?: string;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface Site {
  colorScheme: SiteColors;
  banner: string;
  logo: string;
  status: StatusType;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface PatchSiteDto {
  colorScheme?: SiteColors;
  banner?: string;
  logo?: string;
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface AddSubmitterDto {
  status?: SubmitterStatus;
  role?: string;
  name?: string;
  email: string;
  /** @format double */
  id: number;
}

export interface AddSubmissionDto {
  submitters?: AddSubmitterDto[];
  createdAt: string;
  /** @format double */
  id: number;
}

export type SendSignRequestResult =
  | {
      missingEmailSubmitterUuids: string[];
      submitters: SubmitterTemplate[];
      status: "needs_review";
    }
  | {
      submission: Submission;
      /** @format double */
      submissionId: number;
      submitters: SubmitterTemplate[];
      status: "sent";
    };

export interface TeamMemberWContact {
  contactInfo: ContactInfo;
  includeInLetterhead?: boolean;
  expirationNotification?: string[];
  expirationDate?: DateType;
  expires?: boolean;
  notifications?: {
    meetingPublished?: boolean;
  };
  class?: TeamMemberClass;
  role: RoleType;
  userId: string;
  title: string;
}

export interface LetterHead {
  nestNumbering?: boolean;
  itemNumbering?: NumberFormat;
  sectionNumbering?: NumberFormat;
  theme?: string;
  layout?: string;
  members: TeamMemberWContact[];
  logoUrl: string;
  phoneNumber: string;
  website?: string;
  email: string;
  name: string;
  viewName?: string;
  tags?: Tag[];
  status: StatusType;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface AgendaItem {
  glAccount?: string;
  expirationNotification?: string[];
  expirationDate?: DateType;
  expires?: boolean;
  motion?: string;
  script?: string;
  comment?: string;
  presenter?: Presenter | string;
  approver?: Approver;
  software?: boolean;
  lease?: boolean;
  docapprovaltype?: DocumentApprovalType;
  term?: string;
  annualPrice?: string;
  price?: string;
  requestedApprovalDate?: DateType;
  biddingThresholds?: string;
  biddingRequired?: boolean;
  emergencyOverride?: boolean;
  prevailingWage?: boolean;
  stateApprovedPricing?: boolean;
  why?: string;
  vendor?: string;
  newVersionOfTheItemId?: string;
  publishedAt?: DateType;
  review?: AgendaItemReview | null;
  teamId?: string;
  parentIds?: string[];
  documents: Document[] | null;
  documentIds: string[];
  type: string;
  submittedBy: string;
  body: string;
  description: string;
  name: string;
  templateId?: string;
  template?: boolean;
  tags?: Tag[];
  status: StatusType;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface AgendaModule {
  publishedAt?: DateType;
  teamId?: string;
  agendaItems: AgendaItem[] | null;
  parentIds?: string[];
  agendaItemIds: string[];
  type: string;
  body: string;
  description: string;
  name: string;
  templateId?: string;
  template?: boolean;
  tags?: Tag[];
  status: StatusType;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface Agenda {
  publishedAt?: DateType;
  teamId?: string;
  parentIds?: string[];
  agendaModules: AgendaModule[] | null;
  agendaModuleIds: string[];
  letterHead: LetterHead | null;
  letterHeadId?: string | null;
  downloadUrl?: string;
  description: string;
  name: string;
  templateId?: string;
  template?: boolean;
  tags?: Tag[];
  status: StatusType;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface Meeting {
  publishedAt: DateType | null;
  agendaPublishedAt?: DateType;
  agendaPdfFilePath?: string;
  agendaPdfFileName?: string;
  agendaUrl?: string;
  meetingTypeOption?: string | string[];
  meetingType?: string;
  teamId?: string;
  letterHead: LetterHead | null;
  letterHeadId?: string | null;
  minutesData?: MeetingMinutesData | null;
  review?: MeetingReview;
  address?: Address;
  agenda: Agenda | null;
  agendaId: string;
  endTime: DateType;
  startTime: DateType;
  description: string;
  name: string;
  tags?: Tag[];
  status: StatusType;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface CreateMeetingDto {
  publishedAt?: DateType | null;
  agendaPublishedAt?: DateType;
  agendaPdfFilePath?: string;
  agendaPdfFileName?: string;
  agendaUrl?: string;
  meetingTypeOption?: string | string[];
  meetingType?: string;
  teamId?: string;
  letterHead?: LetterHead | null;
  letterHeadId?: string | null;
  minutesData?: MeetingMinutesData | null;
  review?: MeetingReview;
  address?: Address;
  agenda?: Agenda | null;
  agendaId?: string;
  endTime?: DateType;
  startTime?: DateType;
  description?: string;
  name?: string;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface PatchMeetingDto {
  publishedAt?: DateType | null;
  agendaPublishedAt?: DateType;
  agendaPdfFilePath?: string;
  agendaPdfFileName?: string;
  agendaUrl?: string;
  meetingTypeOption?: string | string[];
  meetingType?: string;
  teamId?: string;
  letterHead?: LetterHead | null;
  letterHeadId?: string | null;
  minutesData?: MeetingMinutesData | null;
  review?: MeetingReview;
  address?: Address;
  agenda?: Agenda | null;
  agendaId?: string;
  endTime?: DateType;
  startTime?: DateType;
  description?: string;
  name?: string;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface CreateLetterHeadDto {
  nestNumbering?: boolean;
  itemNumbering?: NumberFormat;
  sectionNumbering?: NumberFormat;
  theme?: string;
  layout?: string;
  members?: TeamMemberWContact[];
  logoUrl?: string;
  phoneNumber?: string;
  website?: string;
  email?: string;
  name?: string;
  viewName?: string;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface PatchLetterHeadDto {
  nestNumbering?: boolean;
  itemNumbering?: NumberFormat;
  sectionNumbering?: NumberFormat;
  theme?: string;
  layout?: string;
  members?: TeamMemberWContact[];
  logoUrl?: string;
  phoneNumber?: string;
  website?: string;
  email?: string;
  name?: string;
  viewName?: string;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export type LaserficheConnectionDto =
  | {
      nickname?: string;
      repository: string;
      baseUrl: string;
      hostingType: "self";
    }
  | {
      nickname?: string;
      repository: string;
      hostingType: "cloud";
    };

/** Construct a type with a set of properties K of type T */
export type RecordStringLaserficheConnectionDtoOrNull = Record<
  string,
  LaserficheConnectionDto
>;

export interface LaserficheInspectField {
  constraint?: string;
  /** @format double */
  length?: number;
  description?: string;
  type: string;
  name: string;
  /** @format double */
  id: number;
}

export interface LaserficheInspectTemplate {
  description?: string;
  fields: number[];
  name: string;
  /** @format double */
  id: number;
}

export interface LaserficheInspectTag {
  description?: string;
  name: string;
  /** @format double */
  id: number;
}

export interface LaserficheInspectDirectoryItem {
  path: string;
  /** @format double */
  parentId?: number;
  type: "file" | "folder";
  /** @format double */
  id: number;
  name: string;
}

export interface LaserficheDirectory {
  directoryPath: string;
  /** @format double */
  directoryId: number;
}

export interface LaserficheTag {
  tagName: string;
  /** @format double */
  tagId: number;
}

export interface LaserficheField {
  constantValue?: string;
  sourceKey: string;
  fieldName: string;
  /** @format double */
  fieldId: number;
}

export interface LaserficheTemplate {
  templateFieldAssignments: LaserficheField[];
  templateName: string;
  /** @format double */
  templateId: number;
}

export interface LaserficheMetadata {
  template?: LaserficheTemplate | null;
  fields: LaserficheField[];
  tags: LaserficheTag[];
  enabled: boolean;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringLaserficheMetadata = Record<string, LaserficheMetadata>;

export interface LaserfichePutTag {
  /** @format double */
  tagId: number;
}

export interface LaserfichePutField {
  constantValue?: string;
  sourceKey: string;
  /** @format double */
  fieldId: number;
}

export interface LaserfichePutTemplate {
  templateFieldAssignments: LaserfichePutField[];
  /** @format double */
  templateId: number;
}

export interface LaserfichePutMetadata {
  fields?: LaserfichePutField[];
  template?: LaserfichePutTemplate | null;
  tags?: LaserfichePutTag[];
  enabled?: boolean;
}

export interface LaserficheInternalConfiguration {
  errorEmail?: string;
}

export interface ImportDataUploadResult {
  objectName: string;
  /** @format double */
  sizeKb?: number;
  extension?: string;
  type: string;
  name: string;
  id: string;
}

export interface ImportDataUploadRequest {
  /** @format double */
  sizeKb?: number;
  extension?: string;
  type: string;
  name: string;
  base64File: string;
  objectName: string;
}

export interface UserImportData {
  isDuplicate?: boolean;
  isUserValid: boolean;
  primaryAddress: {
    country: string;
    zip: string;
    state: string;
    city: string;
    street2: string;
    street: string;
    type: string;
  };
  role: RoleType;
  salutation: string;
  email: string;
  lastName: string;
  firstName: string;
}

export interface UserDuplicate {
  newRole: RoleType;
  oldRole: RoleType;
  user: UserImportData;
}

export interface UserImportBindingConfig {
  firstName: string;
  lastName: string;
  email: string;
  salutation: string;
  role: string;
  primaryAddress: {
    country: string;
    zip: string;
    state: string;
    city: string;
    street2: string;
    street: string;
    type: string;
  };
}

export interface UserDuplicateCheckConfig {
  fileId: string;
  bindConfig: UserImportBindingConfig;
}

export interface UserImportConfig {
  fileId: string;
  bindConfig: UserImportBindingConfig;
  isPreview: boolean;
  overwriteDuplicates?: string[];
}

export interface CreateDocumentDto {
  submissionTemplate?: SubmissionTemplate | null;
  publishedAt?: DateType;
  agendaData?: DocumentAgendaData;
  minutesData?: DocumentMinutesData;
  resolutionData?: ResolutionData;
  ordinanceData?: OrdinanceData;
  uploadType?: UploadTypeId;
  visibleOnAgenda?: boolean;
  confidentialReason?: string | string[];
  confidential?: boolean;
  teamId?: string;
  parentIds?: string[];
  attachments?: Attachment[];
  linkedAttachment?: string;
  description?: string;
  name?: string;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface PatchDocumentDto {
  submissionTemplate?: SubmissionTemplate | null;
  publishedAt?: DateType;
  agendaData?: DocumentAgendaData;
  minutesData?: DocumentMinutesData;
  resolutionData?: ResolutionData;
  ordinanceData?: OrdinanceData;
  uploadType?: UploadTypeId;
  visibleOnAgenda?: boolean;
  confidentialReason?: string | string[];
  confidential?: boolean;
  teamId?: string;
  parentIds?: string[];
  attachments?: Attachment[];
  linkedAttachment?: string;
  description?: string;
  name?: string;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface FieldOption {
  label: string;
  value: string | number;
}

export interface FieldProps {
  required?: boolean | string;
  options?: FieldOption[];
  type: FieldType;
  label?: string;
  placeholder?: string;
  name: string;
}

export type FieldLayoutConditionValue =
  | {
      value: boolean | string | number | DateType;
      type: "constant";
    }
  | {
      field: string;
      type: "field";
    };

export interface FieldLayoutCondition {
  operands: (FieldLayoutConditionValue | FieldLayoutCondition)[];
  operator: FieldLayoutConditionOperator;
  type: "condition";
}

export interface FieldLayout {
  children: (string | FieldLayout)[];
  condition?: FieldLayoutCondition;
  defaultCollapsed?: boolean;
  collapsible?: boolean;
  sectionTitle?: string;
}

export interface AgendaItemMetadataConfig {
  layout: FieldLayout;
  fields: FieldProps[];
}

export interface ExampleFile {
  fileType: string;
  fileBits: string;
  fileName: string;
}

export interface ExampleFilesConfig {
  userImportExample: ExampleFile;
}

export interface MeetingOptionType {
  label: string;
  value: string;
}

export interface MeetingTypeOptions {
  options: MeetingOptionType[];
  type: MeetingTypeOptionType;
  optionsLabel: string;
}

export interface MeetingTypeType {
  options?: MeetingTypeOptions;
  value: string;
  label: string;
}

export interface MeetingTypesConfig {
  meetingTypes: MeetingTypeType[];
}

export interface SizeOptions {
  description: string;
  name: string;
  label: string;
}

export interface OrganizationType {
  sizeOptions?: SizeOptions[];
  label: string;
  name: string;
  /** @format double */
  id: number;
}

export interface OrganizationTypesConfig {
  organizationTypes: OrganizationType[];
}

export interface DocumentUploadTypesConfig {
  uploadTypes: {
    example: string;
    storage: "short" | "long";
    label: string;
    id: UploadTypeId;
  }[];
}

export type MotionVotingType = "majority" | "twothirds" | false;

export interface MotionType {
  createAgendaItem?: boolean;
  adjourn?: boolean;
  nicknames?: string[];
  voting: MotionVotingType;
  deferredReason?: string;
  defers: boolean;
  nestable: boolean;
  amend: boolean;
  comment: string | false;
  debate: boolean;
  second: boolean;
  interrupt: boolean;
  description: string;
  type: MotionCategory;
  name: string;
  id: string;
}

export interface MotionTypesConfig {
  meeting: MotionType[];
  item: MotionType[];
}

export interface TermsAndConditionsConfig {
  url?: string;
  /** @format double */
  version?: number;
  updatedAt?: DateType;
  createdAt?: DateType;
}

export interface AIMinutesTemplate {
  data: string;
  name: string;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export interface CreateAIMinutesTemplateDto {
  data?: string;
  name?: string;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface PatchAIMinutesTemplateDto {
  data?: string;
  name?: string;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export type AIAVDataDto =
  | {
      url: string;
      type: "url";
    }
  | {
      path: string;
      type: "upload";
    };

export interface AIJobStatusDto {
  updatedAt: DateType;
  /** @format double */
  progress: number;
  status: AIJobStatus;
  jobId: string;
}

export interface CreateAgendaDto {
  publishedAt?: DateType;
  teamId?: string;
  parentIds?: string[];
  agendaModules?: AgendaModule[] | null;
  agendaModuleIds?: string[];
  letterHead?: LetterHead | null;
  letterHeadId?: string | null;
  downloadUrl?: string;
  description?: string;
  name?: string;
  templateId?: string;
  template?: boolean;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface PatchAgendaDto {
  publishedAt?: DateType;
  teamId?: string;
  parentIds?: string[];
  agendaModules?: AgendaModule[] | null;
  agendaModuleIds?: string[];
  letterHead?: LetterHead | null;
  letterHeadId?: string | null;
  downloadUrl?: string;
  description?: string;
  name?: string;
  templateId?: string;
  template?: boolean;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface CreateAgendaModuleDto {
  publishedAt?: DateType;
  teamId?: string;
  agendaItems?: AgendaItem[] | null;
  parentIds?: string[];
  agendaItemIds?: string[];
  type?: string;
  body?: string;
  description?: string;
  name?: string;
  templateId?: string;
  template?: boolean;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface PatchAgendaModuleDto {
  publishedAt?: DateType;
  teamId?: string;
  agendaItems?: AgendaItem[] | null;
  parentIds?: string[];
  agendaItemIds?: string[];
  type?: string;
  body?: string;
  description?: string;
  name?: string;
  templateId?: string;
  template?: boolean;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface CreateAgendaItemDto {
  glAccount?: string;
  expirationNotification?: string[];
  expirationDate?: DateType;
  expires?: boolean;
  motion?: string;
  script?: string;
  comment?: string;
  presenter?: Presenter | string;
  approver?: Approver;
  software?: boolean;
  lease?: boolean;
  docapprovaltype?: DocumentApprovalType;
  term?: string;
  annualPrice?: string;
  price?: string;
  requestedApprovalDate?: DateType;
  biddingThresholds?: string;
  biddingRequired?: boolean;
  emergencyOverride?: boolean;
  prevailingWage?: boolean;
  stateApprovedPricing?: boolean;
  why?: string;
  vendor?: string;
  newVersionOfTheItemId?: string;
  publishedAt?: DateType;
  review?: AgendaItemReview | null;
  teamId?: string;
  parentIds?: string[];
  documents?: Document[] | null;
  documentIds?: string[];
  type?: string;
  submittedBy?: string;
  body?: string;
  description?: string;
  name?: string;
  templateId?: string;
  template?: boolean;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface PatchAgendaItemDto {
  glAccount?: string;
  expirationNotification?: string[];
  expirationDate?: DateType;
  expires?: boolean;
  motion?: string;
  script?: string;
  comment?: string;
  presenter?: Presenter | string;
  approver?: Approver;
  software?: boolean;
  lease?: boolean;
  docapprovaltype?: DocumentApprovalType;
  term?: string;
  annualPrice?: string;
  price?: string;
  requestedApprovalDate?: DateType;
  biddingThresholds?: string;
  biddingRequired?: boolean;
  emergencyOverride?: boolean;
  prevailingWage?: boolean;
  stateApprovedPricing?: boolean;
  why?: string;
  vendor?: string;
  newVersionOfTheItemId?: string;
  publishedAt?: DateType;
  review?: AgendaItemReview | null;
  teamId?: string;
  parentIds?: string[];
  documents?: Document[] | null;
  documentIds?: string[];
  type?: string;
  submittedBy?: string;
  body?: string;
  description?: string;
  name?: string;
  templateId?: string;
  template?: boolean;
  tags?: Tag[];
  status?: StatusType;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export interface Account {
  lastName: string;
  firstName: string;
  lastLoginTime: DateType;
  image?: string | null;
  emailVerified: boolean | null;
  email: string;
  name?: string;
  updatedBy: string;
  createdBy: string;
  updatedAt: DateType;
  createdAt: DateType;
  id: string;
  _source: SourceType;
  /** @format double */
  _schemaVersion: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version: number;
  _deleted: boolean;
}

export type CreateAccountDto = {
  lastName?: string;
  firstName?: string;
  lastLoginTime?: DateType;
  image?: string | null;
  emailVerified?: boolean | null;
  email?: string;
  name?: string;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
} & {
  lastName: string;
  firstName: string;
  email: string;
};

export interface PatchAccountDto {
  lastName?: string;
  firstName?: string;
  lastLoginTime?: DateType;
  image?: string | null;
  emailVerified?: boolean | null;
  email?: string;
  name?: string;
  updatedBy?: string;
  createdBy?: string;
  updatedAt?: DateType;
  createdAt?: DateType;
  id?: string;
  _source?: SourceType;
  /** @format double */
  _schemaVersion?: number;
  _preserveVersion?: boolean;
  /** @format double */
  _version?: number;
  _deleted?: boolean;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** function name */
  funcName: string;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path" | "funcName"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
  // filters for incoming / outgoing json data */
  requestBodyFilter?: (data: any, funcName: string) => any;
  responseBodyFilter?: (data: any, funcName: string) => any;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);
  private requestBodyFilter = (data: any, _funcName: string) => data;
  private responseBodyFilter = (data: any, _funcName: string) => data;

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    funcName,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    body = await this.requestBodyFilter(body, funcName);

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then(async (data) => {
              if (r.ok) {
                r.data = await this.responseBodyFilter(data, funcName);
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title api
 * @version 0.13.0
 * @baseUrl /
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description Send a superadmin notice email to all registered emails in the system.
     *
     * @tags superadmin, private
     * @name AdminNotify
     * @request POST:/v1/superadmin/notify
     * @secure
     */
    adminNotify: (
      data: {
        /** Construct a type with a set of properties K of type T */
        data: RecordStringString;
        type: string;
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/superadmin/notify`,
        method: "POST",
        funcName: "adminNotify",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Run a manual backup of one or all tenants. Downloads database data, associated users, and uploaded files of the selected tenant(s).
     *
     * @tags superadmin, private
     * @name Backup
     * @request POST:/v1/superadmin/backups/backup
     * @secure
     */
    backup: (
      data: {
        tenant?: string | null;
        totp?: string | null;
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/superadmin/backups/backup`,
        method: "POST",
        funcName: "backup",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Restore a backup from a json file.
     *
     * @tags superadmin, private
     * @name Restore
     * @request POST:/v1/superadmin/backups/restore
     * @secure
     */
    restore: (
      data: {
        data: string;
        totp?: string | null;
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | {
            error: any;
            path: string;
            type: string;
          }[]
        | null,
        any
      >({
        path: `/v1/superadmin/backups/restore`,
        method: "POST",
        funcName: "restore",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Run an integrity scan of the database data. This check is outdated since it assumes data should be getting copied. It will likely find many false positives.
     *
     * @tags superadmin, private
     * @name IntegrityCheck
     * @request POST:/v1/superadmin/integrity/check
     * @secure
     */
    integrityCheck: (
      data: {
        tenant?: string | null;
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string[], any>({
        path: `/v1/superadmin/integrity/check`,
        method: "POST",
        funcName: "integrityCheck",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Clears all cache from the caching service. Call this endpoint after making manual database changes to force the server to load the new data from the database.
     *
     * @tags superadmin, private
     * @name ClearCache
     * @request POST:/v1/superadmin/cache/clear
     * @secure
     */
    clearCache: (
      data: {
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/superadmin/cache/clear`,
        method: "POST",
        funcName: "clearCache",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description User Logged-in Test Endpoint
     *
     * @tags users
     * @name GetUserTest
     * @request GET:/v1/publicUsers/test
     * @secure
     */
    getUserTest: (params: RequestParams = {}) =>
      this.request<DecodedIdToken, any>({
        path: `/v1/publicUsers/test`,
        method: "GET",
        funcName: "getUserTest",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the details for a single public user by id.
     *
     * @tags users
     * @name GetPublicUser
     * @request GET:/v1/publicUsers/{id}
     */
    getPublicUser: (id: string, params: RequestParams = {}) =>
      this.request<PublicUser | null, any>({
        path: `/v1/publicUsers/${id}`,
        method: "GET",
        funcName: "getPublicUser",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants
     * @name GetPublicTenant
     * @request GET:/v1/publicTenants/{id}
     */
    getPublicTenant: (id: string, params: RequestParams = {}) =>
      this.request<PublicTenant | null, any>({
        path: `/v1/publicTenants/${id}`,
        method: "GET",
        funcName: "getPublicTenant",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags team
     * @name ListPublicTeams
     * @request GET:/v1/publicTenants/{tenantId}/teams
     */
    listPublicTeams: (
      tenantId: string,
      query?: {
        /** @format double */
        limit?: number;
        /** @format double */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicTeam[], any>({
        path: `/v1/publicTenants/${tenantId}/teams`,
        method: "GET",
        funcName: "listPublicTeams",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags team
     * @name GetPublicTeam
     * @request GET:/v1/publicTenants/{tenantId}/teams/{id}
     */
    getPublicTeam: (tenantId: string, id: string, params: RequestParams = {}) =>
      this.request<PublicTeam | null, any>({
        path: `/v1/publicTenants/${tenantId}/teams/${id}`,
        method: "GET",
        funcName: "getPublicTeam",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags municipality
     * @name GetMunicipalities
     * @request GET:/v1/municipality
     */
    getMunicipalities: (
      query?: {
        /** @format double */
        page?: number;
        /** @format double */
        limit?: number;
        state?: string;
        county?: string;
        type?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          pagination: Pagination;
          data: Municipality[];
        },
        any
      >({
        path: `/v1/municipality`,
        method: "GET",
        funcName: "getMunicipalities",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags municipality
     * @name GetStates
     * @request GET:/v1/municipality/states
     */
    getStates: (params: RequestParams = {}) =>
      this.request<
        {
          data: string[];
        },
        any
      >({
        path: `/v1/municipality/states`,
        method: "GET",
        funcName: "getStates",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags municipality
     * @name GetMunicipalitiesForState
     * @request GET:/v1/municipality/states/{state}
     */
    getMunicipalitiesForState: (
      state: string,
      query?: {
        /** @format double */
        page?: number;
        /** @format double */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          pagination: Pagination;
          data: Municipality[];
        },
        any
      >({
        path: `/v1/municipality/states/${state}`,
        method: "GET",
        funcName: "getMunicipalitiesForState",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags municipality
     * @name GetMunicipality
     * @request GET:/v1/municipality/{id}
     */
    getMunicipality: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: {
            /** @format double */
            population_based_rate: number;
            /** @format double */
            rate: number;
            /** @format double */
            population: number;
            name: string;
            type: string;
            /** @format double */
            typeId: number;
            county: string;
            /** @format double */
            countyId: number;
            state: string;
            /** @format double */
            stateId: number;
            /** @format double */
            id: number;
          };
        },
        any
      >({
        path: `/v1/municipality/${id}`,
        method: "GET",
        funcName: "getMunicipality",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags payment
     * @name GetSession
     * @request GET:/v1/payment/session/{sessionId}
     */
    getSession: (sessionId: string, params: RequestParams = {}) =>
      this.request<
        {
          subscriptionStripeId: string;
          customerStripeId: string;
          customerStripeEmail: string;
          status: StripeCheckoutSessionStatus | null;
        },
        any
      >({
        path: `/v1/payment/session/${sessionId}`,
        method: "GET",
        funcName: "getSession",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags payment
     * @name CreateProductPrice
     * @request POST:/v1/payment/product/price
     */
    createProductPrice: (
      query: {
        municipalityIdExtended: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          prices: {
            interval: "day" | "week" | "month" | "year";
            productId: string;
            /** @format double */
            price: number;
            description: string;
            title: string;
          }[];
        },
        any
      >({
        path: `/v1/payment/product/price`,
        method: "POST",
        funcName: "createProductPrice",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags payment
     * @name CreateSession
     * @request POST:/v1/payment/session
     */
    createSession: (
      query: {
        customerEmail: string;
        productId: string;
        discountCode?: string;
        returnUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          clientSecret: string | null;
        },
        any
      >({
        path: `/v1/payment/session`,
        method: "POST",
        funcName: "createSession",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags payment
     * @name GetCustomersByEmail
     * @request GET:/v1/payment/customer
     */
    getCustomersByEmail: (
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Construct a type with a set of properties K of type T */
          metadata: RecordStringString;
          subscriptions: {
            status: StripeSubscriptionStatus;
            id: string;
          }[];
          email: string | null;
          stripeId: string;
        },
        {
          error: string;
        }
      >({
        path: `/v1/payment/customer`,
        method: "GET",
        funcName: "getCustomersByEmail",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags payment
     * @name GetCoupon
     * @request GET:/v1/payment/coupon/{couponId}
     */
    getCoupon: (couponId: string, params: RequestParams = {}) =>
      this.request<PromotionCode, any>({
        path: `/v1/payment/coupon/${couponId}`,
        method: "GET",
        funcName: "getCoupon",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site
     * @name GetPublicSite
     * @request GET:/v1/publicTenants/{tenantId}/site
     */
    getPublicSite: (tenantId: string, params: RequestParams = {}) =>
      this.request<PublicSite | null, any>({
        path: `/v1/publicTenants/${tenantId}/site`,
        method: "GET",
        funcName: "getPublicSite",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meeting
     * @name ListPublicMeetings
     * @request GET:/v1/publicTenants/{tenantId}/meetings
     */
    listPublicMeetings: (
      tenantId: string,
      query?: {
        /** @format double */
        limit?: number;
        /** @format double */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicMeeting[], any>({
        path: `/v1/publicTenants/${tenantId}/meetings`,
        method: "GET",
        funcName: "listPublicMeetings",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meeting
     * @name GetPublicMeeting
     * @request GET:/v1/publicTenants/{tenantId}/meetings/{id}
     */
    getPublicMeeting: (
      tenantId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PublicMeeting | null, any>({
        path: `/v1/publicTenants/${tenantId}/meetings/${id}`,
        method: "GET",
        funcName: "getPublicMeeting",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meeting
     * @name GetMeetingAgendaPdf
     * @request GET:/v1/publicTenants/{tenantId}/meetings/{id}/agendaPdf
     */
    getMeetingAgendaPdf: (
      tenantId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/publicTenants/${tenantId}/meetings/${id}/agendaPdf`,
        method: "GET",
        funcName: "getMeetingAgendaPdf",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document
     * @name ListPublicDocuments
     * @request GET:/v1/publicTenants/{tenantId}/documents
     */
    listPublicDocuments: (
      tenantId: string,
      query?: {
        /** @format double */
        limit?: number;
        /** @format double */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicDocument[], any>({
        path: `/v1/publicTenants/${tenantId}/documents`,
        method: "GET",
        funcName: "listPublicDocuments",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document
     * @name GetPublicDocument
     * @request GET:/v1/publicTenants/{tenantId}/documents/{id}
     */
    getPublicDocument: (
      tenantId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PublicDocument | null, any>({
        path: `/v1/publicTenants/${tenantId}/documents/${id}`,
        method: "GET",
        funcName: "getPublicDocument",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document
     * @name DownloadPublicDocument
     * @request GET:/v1/publicTenants/{tenantId}/documents/{id}/download
     */
    downloadPublicDocument: (
      tenantId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/v1/publicTenants/${tenantId}/documents/${id}/download`,
        method: "GET",
        funcName: "downloadPublicDocument",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document
     * @name DownloadPublicAttachment
     * @request GET:/v1/publicTenants/{tenantId}/documents/{id}/download/{attachmentType}
     */
    downloadPublicAttachment: (
      tenantId: string,
      id: string,
      attachmentType: string,
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/v1/publicTenants/${tenantId}/documents/${id}/download/${attachmentType}`,
        method: "GET",
        funcName: "downloadPublicAttachment",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags config
     * @name GetPublicConfig
     * @request GET:/v1/config
     */
    getPublicConfig: (params: RequestParams = {}) =>
      this.request<
        {
          configData: AppConfig;
        },
        any
      >({
        path: `/v1/config`,
        method: "GET",
        funcName: "getPublicConfig",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agenda
     * @name ListPublicAgendas
     * @request GET:/v1/publicTenants/{tenantId}/agendas
     */
    listPublicAgendas: (
      tenantId: string,
      query?: {
        /** @format double */
        limit?: number;
        /** @format double */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicAgenda[], any>({
        path: `/v1/publicTenants/${tenantId}/agendas`,
        method: "GET",
        funcName: "listPublicAgendas",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agenda
     * @name GetPublicAgenda
     * @request GET:/v1/publicTenants/{tenantId}/agendas/{id}
     */
    getPublicAgenda: (
      tenantId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PublicAgenda | null, any>({
        path: `/v1/publicTenants/${tenantId}/agendas/${id}`,
        method: "GET",
        funcName: "getPublicAgenda",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaModule
     * @name ListPublicAgendaModules
     * @request GET:/v1/publicTenants/{tenantId}/agendaModules
     */
    listPublicAgendaModules: (
      tenantId: string,
      query?: {
        /** @format double */
        limit?: number;
        /** @format double */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicAgendaModule[], any>({
        path: `/v1/publicTenants/${tenantId}/agendaModules`,
        method: "GET",
        funcName: "listPublicAgendaModules",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaModule
     * @name GetPublicAgendaModule
     * @request GET:/v1/publicTenants/{tenantId}/agendaModules/{id}
     */
    getPublicAgendaModule: (
      tenantId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PublicAgendaModule | null, any>({
        path: `/v1/publicTenants/${tenantId}/agendaModules/${id}`,
        method: "GET",
        funcName: "getPublicAgendaModule",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaItem
     * @name ListPublicAgendaItems
     * @request GET:/v1/publicTenants/{tenantId}/agendaItems
     */
    listPublicAgendaItems: (
      tenantId: string,
      query?: {
        /** @format double */
        limit?: number;
        /** @format double */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicAgendaItem[], any>({
        path: `/v1/publicTenants/${tenantId}/agendaItems`,
        method: "GET",
        funcName: "listPublicAgendaItems",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaItem
     * @name GetPublicAgendaItem
     * @request GET:/v1/publicTenants/{tenantId}/agendaItems/{id}
     */
    getPublicAgendaItem: (
      tenantId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PublicAgendaItem | null, any>({
        path: `/v1/publicTenants/${tenantId}/agendaItems/${id}`,
        method: "GET",
        funcName: "getPublicAgendaItem",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, private
     * @name GetUserByEmail
     * @request GET:/v1/users/by/email
     * @secure
     */
    getUserByEmail: (
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<User | null, any>({
        path: `/v1/users/by/email`,
        method: "GET",
        funcName: "getUserByEmail",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, private
     * @name CreateMyUser
     * @request POST:/v1/users/me
     * @secure
     */
    createMyUser: (
      data: {
        userData: {
          lastName: string;
          firstName: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<User, any>({
        path: `/v1/users/me`,
        method: "POST",
        funcName: "createMyUser",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, private
     * @name CreateNewUser
     * @request POST:/v1/users
     * @secure
     */
    createNewUser: (
      data: {
        userData: {
          email: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<User, any>({
        path: `/v1/users`,
        method: "POST",
        funcName: "createNewUser",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, private
     * @name MailWelcome
     * @request POST:/v1/users/mail/welcome
     * @secure
     */
    mailWelcome: (
      data: {
        tenantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/users/mail/welcome`,
        method: "POST",
        funcName: "mailWelcome",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, private
     * @name MailNewUser
     * @request POST:/v1/users/mail/new
     * @secure
     */
    mailNewUser: (
      data: {
        email: string;
        tenantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/users/mail/new`,
        method: "POST",
        funcName: "mailNewUser",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, private
     * @name GetUser
     * @request GET:/v1/users/{userId}
     * @secure
     */
    getUser: (userId: string, params: RequestParams = {}) =>
      this.request<User | null, any>({
        path: `/v1/users/${userId}`,
        method: "GET",
        funcName: "getUser",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, private
     * @name UpdateUser
     * @request PATCH:/v1/users/{userId}
     * @secure
     */
    updateUser: (
      userId: string,
      data: PatchUserDto,
      params: RequestParams = {},
    ) =>
      this.request<User, any>({
        path: `/v1/users/${userId}`,
        method: "PATCH",
        funcName: "updateUser",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants, private
     * @name CreateNewTenant
     * @request POST:/v1/tenants
     * @secure
     */
    createNewTenant: (
      data: {
        tenantData: {
          organizationMunicipalityTypeId?: string;
          organizationMunicipalityType?: string;
          /** @format double */
          organizationMunicipalityPopulation?: number;
          organizationMunicipalityName?: string;
          organizationMunicipalityId?: string;
          organizationState?: string;
          name: string;
          friendlyId: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<Tenant, any>({
        path: `/v1/tenants`,
        method: "POST",
        funcName: "createNewTenant",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants, private
     * @name AccessTenant
     * @request POST:/v1/tenants/{tenantId}/access
     * @secure
     */
    accessTenant: (tenantId: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/access`,
        method: "POST",
        funcName: "accessTenant",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants, private
     * @name GetAccessibleTenants
     * @request GET:/v1/tenants/by/user
     * @secure
     */
    getAccessibleTenants: (params: RequestParams = {}) =>
      this.request<Tenant[], any>({
        path: `/v1/tenants/by/user`,
        method: "GET",
        funcName: "getAccessibleTenants",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants, private
     * @name GetUsersInTenant
     * @request GET:/v1/tenants/{tenantId}/users
     * @secure
     */
    getUsersInTenant: (tenantId: string, params: RequestParams = {}) =>
      this.request<UserWRole[], any>({
        path: `/v1/tenants/${tenantId}/users`,
        method: "GET",
        funcName: "getUsersInTenant",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants, private
     * @name AddUserToTenant
     * @request POST:/v1/tenants/{tenantId}/user
     * @secure
     */
    addUserToTenant: (
      tenantId: string,
      data: {
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/user`,
        method: "POST",
        funcName: "addUserToTenant",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants, private
     * @name RemoveUserFromTenant
     * @request DELETE:/v1/tenants/{tenantId}/user/{userId}
     * @secure
     */
    removeUserFromTenant: (
      tenantId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/user/${userId}`,
        method: "DELETE",
        funcName: "removeUserFromTenant",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants, private
     * @name GetTenantByFriendlyId
     * @request GET:/v1/tenants/by/friendlyId
     * @secure
     */
    getTenantByFriendlyId: (
      query: {
        friendlyId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Tenant | null, any>({
        path: `/v1/tenants/by/friendlyId`,
        method: "GET",
        funcName: "getTenantByFriendlyId",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants, private
     * @name GetTenant
     * @request GET:/v1/tenants/{tenantId}
     * @secure
     */
    getTenant: (tenantId: string, params: RequestParams = {}) =>
      this.request<Tenant | null, any>({
        path: `/v1/tenants/${tenantId}`,
        method: "GET",
        funcName: "getTenant",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tenants, private
     * @name UpdateTenant
     * @request PATCH:/v1/tenants/{tenantId}
     * @secure
     */
    updateTenant: (
      tenantId: string,
      data: PatchTenantDto,
      params: RequestParams = {},
    ) =>
      this.request<Tenant, any>({
        path: `/v1/tenants/${tenantId}`,
        method: "PATCH",
        funcName: "updateTenant",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams, private
     * @name ListTeams
     * @request GET:/v1/tenants/{tenantId}/teams
     * @secure
     */
    listTeams: (tenantId: string, params: RequestParams = {}) =>
      this.request<Team[], any>({
        path: `/v1/tenants/${tenantId}/teams`,
        method: "GET",
        funcName: "listTeams",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams, private
     * @name CreateTeam
     * @request POST:/v1/tenants/{tenantId}/teams
     * @secure
     */
    createTeam: (
      tenantId: string,
      data: CreateTeamDto,
      params: RequestParams = {},
    ) =>
      this.request<Team, any>({
        path: `/v1/tenants/${tenantId}/teams`,
        method: "POST",
        funcName: "createTeam",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams, private
     * @name GetTeam
     * @request GET:/v1/tenants/{tenantId}/teams/{teamId}
     * @secure
     */
    getTeam: (tenantId: string, teamId: string, params: RequestParams = {}) =>
      this.request<Team | null, any>({
        path: `/v1/tenants/${tenantId}/teams/${teamId}`,
        method: "GET",
        funcName: "getTeam",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams, private
     * @name UpdateTeam
     * @request PATCH:/v1/tenants/{tenantId}/teams/{teamId}
     * @secure
     */
    updateTeam: (
      tenantId: string,
      teamId: string,
      data: PatchTeamDto,
      params: RequestParams = {},
    ) =>
      this.request<Team, any>({
        path: `/v1/tenants/${tenantId}/teams/${teamId}`,
        method: "PATCH",
        funcName: "updateTeam",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams, private
     * @name DeleteTeam
     * @request DELETE:/v1/tenants/{tenantId}/teams/{teamId}
     * @secure
     */
    deleteTeam: (
      tenantId: string,
      teamId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/teams/${teamId}`,
        method: "DELETE",
        funcName: "deleteTeam",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site, private
     * @name GetSite
     * @request GET:/v1/tenants/{tenantId}/site
     * @secure
     */
    getSite: (tenantId: string, params: RequestParams = {}) =>
      this.request<Site | null, any>({
        path: `/v1/tenants/${tenantId}/site`,
        method: "GET",
        funcName: "getSite",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site, private
     * @name UpdateSite
     * @request PATCH:/v1/tenants/{tenantId}/site
     * @secure
     */
    updateSite: (
      tenantId: string,
      data: PatchSiteDto,
      params: RequestParams = {},
    ) =>
      this.request<Site, any>({
        path: `/v1/tenants/${tenantId}/site`,
        method: "PATCH",
        funcName: "updateSite",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name CreateSignRequestTemplate
     * @request POST:/v1/tenants/{tenantId}/documents/{documentId}/signrequests
     * @secure
     */
    createSignRequestTemplate: (
      tenantId: string,
      documentId: string,
      data: {
        /** @format date-time */
        expirationDate?: Date;
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          slug: string;
          /** @format double */
          templateId: number;
        },
        any
      >({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests`,
        method: "POST",
        funcName: "createSignRequestTemplate",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name DeleteSignRequestTemplate
     * @request DELETE:/v1/tenants/{tenantId}/documents/{documentId}/signrequests
     * @secure
     */
    deleteSignRequestTemplate: (
      tenantId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests`,
        method: "DELETE",
        funcName: "deleteSignRequestTemplate",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name SetSignRequestExpirationDate
     * @request POST:/v1/tenants/{tenantId}/documents/{documentId}/signrequests/expirationDate
     * @secure
     */
    setSignRequestExpirationDate: (
      tenantId: string,
      documentId: string,
      data: {
        /** @format date-time */
        expirationDate: Date | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests/expirationDate`,
        method: "POST",
        funcName: "setSignRequestExpirationDate",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name OnSignRequestSend
     * @request POST:/v1/tenants/{tenantId}/documents/{documentId}/signrequests/onSend
     * @secure
     */
    onSignRequestSend: (
      tenantId: string,
      documentId: string,
      data: AddSubmissionDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests/onSend`,
        method: "POST",
        funcName: "onSignRequestSend",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name SendSignRequest
     * @request POST:/v1/tenants/{tenantId}/documents/{documentId}/signrequests/send
     * @secure
     */
    sendSignRequest: (
      tenantId: string,
      documentId: string,
      data: {
        submitters?: {
          email: string;
          uuid: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<SendSignRequestResult, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests/send`,
        method: "POST",
        funcName: "sendSignRequest",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name OnSignRequestCancel
     * @request POST:/v1/tenants/{tenantId}/documents/{documentId}/signrequests/onCancel
     * @secure
     */
    onSignRequestCancel: (
      tenantId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests/onCancel`,
        method: "POST",
        funcName: "onSignRequestCancel",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name GetSignRequestEditToken
     * @request GET:/v1/tenants/{tenantId}/documents/{documentId}/signrequests/editToken
     * @secure
     */
    getSignRequestEditToken: (
      tenantId: string,
      documentId: string,
      query?: {
        preview?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          editToken: string;
        },
        any
      >({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests/editToken`,
        method: "GET",
        funcName: "getSignRequestEditToken",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name ResendSignRequests
     * @request POST:/v1/tenants/{tenantId}/documents/{documentId}/signrequests/resend
     * @secure
     */
    resendSignRequests: (
      tenantId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests/resend`,
        method: "POST",
        funcName: "resendSignRequests",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name ResendSignRequest
     * @request POST:/v1/tenants/{tenantId}/documents/{documentId}/signrequests/resend/submitter/{submitterId}
     * @secure
     */
    resendSignRequest: (
      tenantId: string,
      documentId: string,
      submitterId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests/resend/submitter/${submitterId}`,
        method: "POST",
        funcName: "resendSignRequest",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name StopSubmission
     * @request PATCH:/v1/tenants/{tenantId}/documents/{documentId}/signrequests/stop
     * @secure
     */
    stopSubmission: (
      tenantId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests/stop`,
        method: "PATCH",
        funcName: "stopSubmission",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name UpdateSubmitters
     * @request PATCH:/v1/tenants/{tenantId}/documents/{documentId}/signrequests/updateSubmitters
     * @secure
     */
    updateSubmitters: (
      tenantId: string,
      documentId: string,
      data: {
        submitters: SubmitterTemplate[];
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/signrequests/updateSubmitters`,
        method: "PATCH",
        funcName: "updateSubmitters",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags misc, private
     * @name SubmitContactForm
     * @request POST:/v1/misc/contact/submit
     * @secure
     */
    submitContactForm: (
      data: {
        browserInfo: {
          platform: string;
          userAgent: string;
        } | null;
        message: string;
        subject: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/misc/contact/submit`,
        method: "POST",
        funcName: "submitContactForm",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings, private
     * @name PublishMeeting
     * @request POST:/v1/tenants/{tenantId}/meetings/{meetingId}/publish
     * @secure
     */
    publishMeeting: (
      tenantId: string,
      meetingId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          errors: string[];
          success: boolean;
        },
        any
      >({
        path: `/v1/tenants/${tenantId}/meetings/${meetingId}/publish`,
        method: "POST",
        funcName: "publishMeeting",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings, private
     * @name SendToLaserfiche
     * @request POST:/v1/tenants/{tenantId}/meetings/{meetingId}/push-laserfiche
     * @secure
     */
    sendToLaserfiche: (
      tenantId: string,
      meetingId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          errors: string[];
          success: boolean;
        },
        any
      >({
        path: `/v1/tenants/${tenantId}/meetings/${meetingId}/push-laserfiche`,
        method: "POST",
        funcName: "sendToLaserfiche",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings, private
     * @name MailMeetingPdf
     * @request POST:/v1/tenants/{tenantId}/meetings/{meetingId}/mail/pdf
     * @secure
     */
    mailMeetingPdf: (
      tenantId: string,
      meetingId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/meetings/${meetingId}/mail/pdf`,
        method: "POST",
        funcName: "mailMeetingPdf",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings, private
     * @name ListMeetings
     * @request GET:/v1/tenants/{tenantId}/meetings
     * @secure
     */
    listMeetings: (tenantId: string, params: RequestParams = {}) =>
      this.request<Meeting[], any>({
        path: `/v1/tenants/${tenantId}/meetings`,
        method: "GET",
        funcName: "listMeetings",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings, private
     * @name CreateMeeting
     * @request POST:/v1/tenants/{tenantId}/meetings
     * @secure
     */
    createMeeting: (
      tenantId: string,
      data: CreateMeetingDto,
      params: RequestParams = {},
    ) =>
      this.request<Meeting, any>({
        path: `/v1/tenants/${tenantId}/meetings`,
        method: "POST",
        funcName: "createMeeting",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings, private
     * @name GetMeeting
     * @request GET:/v1/tenants/{tenantId}/meetings/{meetingId}
     * @secure
     */
    getMeeting: (
      tenantId: string,
      meetingId: string,
      params: RequestParams = {},
    ) =>
      this.request<Meeting | null, any>({
        path: `/v1/tenants/${tenantId}/meetings/${meetingId}`,
        method: "GET",
        funcName: "getMeeting",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings, private
     * @name UpdateMeeting
     * @request PATCH:/v1/tenants/{tenantId}/meetings/{meetingId}
     * @secure
     */
    updateMeeting: (
      tenantId: string,
      meetingId: string,
      data: PatchMeetingDto,
      params: RequestParams = {},
    ) =>
      this.request<Meeting, any>({
        path: `/v1/tenants/${tenantId}/meetings/${meetingId}`,
        method: "PATCH",
        funcName: "updateMeeting",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings, private
     * @name DeleteMeeting
     * @request DELETE:/v1/tenants/{tenantId}/meetings/{meetingId}
     * @secure
     */
    deleteMeeting: (
      tenantId: string,
      meetingId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/meetings/${meetingId}`,
        method: "DELETE",
        funcName: "deleteMeeting",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags private, letterheads
     * @name ListLetterheads
     * @request GET:/v1/tenants/{tenantId}/letterheads
     * @secure
     */
    listLetterheads: (tenantId: string, params: RequestParams = {}) =>
      this.request<LetterHead[], any>({
        path: `/v1/tenants/${tenantId}/letterheads`,
        method: "GET",
        funcName: "listLetterheads",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags private, letterheads
     * @name CreateLetterhead
     * @request POST:/v1/tenants/{tenantId}/letterheads
     * @secure
     */
    createLetterhead: (
      tenantId: string,
      data: CreateLetterHeadDto,
      params: RequestParams = {},
    ) =>
      this.request<LetterHead, any>({
        path: `/v1/tenants/${tenantId}/letterheads`,
        method: "POST",
        funcName: "createLetterhead",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags private, letterheads
     * @name GetLetterhead
     * @request GET:/v1/tenants/{tenantId}/letterheads/{letterheadId}
     * @secure
     */
    getLetterhead: (
      tenantId: string,
      letterheadId: string,
      params: RequestParams = {},
    ) =>
      this.request<LetterHead | null, any>({
        path: `/v1/tenants/${tenantId}/letterheads/${letterheadId}`,
        method: "GET",
        funcName: "getLetterhead",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags private, letterheads
     * @name UpdateLetterhead
     * @request PATCH:/v1/tenants/{tenantId}/letterheads/{letterheadId}
     * @secure
     */
    updateLetterhead: (
      tenantId: string,
      letterheadId: string,
      data: PatchLetterHeadDto,
      params: RequestParams = {},
    ) =>
      this.request<LetterHead, any>({
        path: `/v1/tenants/${tenantId}/letterheads/${letterheadId}`,
        method: "PATCH",
        funcName: "updateLetterhead",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags private, letterheads
     * @name DeleteLetterhead
     * @request DELETE:/v1/tenants/{tenantId}/letterheads/{letterheadId}
     * @secure
     */
    deleteLetterhead: (
      tenantId: string,
      letterheadId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/letterheads/${letterheadId}`,
        method: "DELETE",
        funcName: "deleteLetterhead",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheCreateSelfhosted
     * @request POST:/v1/tenants/{tenantId}/integrations/laserfiche/create/self
     * @secure
     */
    integrationLaserficheCreateSelfhosted: (
      tenantId: string,
      data: {
        password: string;
        username: string;
        nickname?: string;
        repository: string;
        baseUrl: string;
      },
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/create/self`,
        method: "POST",
        funcName: "integrationLaserficheCreateSelfhosted",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheCreateCloudhosted
     * @request POST:/v1/tenants/{tenantId}/integrations/laserfiche/create/cloud
     * @secure
     */
    integrationLaserficheCreateCloudhosted: (
      tenantId: string,
      data: {
        accessKey: string;
        servicePrincipalKey: string;
        repository: string;
        nickname?: string;
      },
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/create/cloud`,
        method: "POST",
        funcName: "integrationLaserficheCreateCloudhosted",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheGetConnection
     * @request GET:/v1/tenants/{tenantId}/integrations/laserfiche
     * @secure
     */
    integrationLaserficheGetConnection: (
      tenantId: string,
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LaserficheConnectionDto | null, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche`,
        method: "GET",
        funcName: "integrationLaserficheGetConnection",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheDeleteConnection
     * @request DELETE:/v1/tenants/{tenantId}/integrations/laserfiche
     * @secure
     */
    integrationLaserficheDeleteConnection: (
      tenantId: string,
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche`,
        method: "DELETE",
        funcName: "integrationLaserficheDeleteConnection",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheListConnections
     * @request GET:/v1/tenants/{tenantId}/integrations/laserfiche/connections
     * @secure
     */
    integrationLaserficheListConnections: (
      tenantId: string,
      params: RequestParams = {},
    ) =>
      this.request<RecordStringLaserficheConnectionDtoOrNull, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/connections`,
        method: "GET",
        funcName: "integrationLaserficheListConnections",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheInspectFields
     * @request GET:/v1/tenants/{tenantId}/integrations/laserfiche/inspect/fields
     * @secure
     */
    integrationLaserficheInspectFields: (
      tenantId: string,
      query?: {
        /** @default null */
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LaserficheInspectField[], any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/inspect/fields`,
        method: "GET",
        funcName: "integrationLaserficheInspectFields",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheInspectTemplates
     * @request GET:/v1/tenants/{tenantId}/integrations/laserfiche/inspect/templates
     * @secure
     */
    integrationLaserficheInspectTemplates: (
      tenantId: string,
      query?: {
        /** @default null */
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LaserficheInspectTemplate[], any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/inspect/templates`,
        method: "GET",
        funcName: "integrationLaserficheInspectTemplates",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheInspectTags
     * @request GET:/v1/tenants/{tenantId}/integrations/laserfiche/inspect/tags
     * @secure
     */
    integrationLaserficheInspectTags: (
      tenantId: string,
      query?: {
        /** @default null */
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LaserficheInspectTag[], any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/inspect/tags`,
        method: "GET",
        funcName: "integrationLaserficheInspectTags",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheInspectDirectory
     * @request GET:/v1/tenants/{tenantId}/integrations/laserfiche/inspect/directory
     * @secure
     */
    integrationLaserficheInspectDirectory: (
      tenantId: string,
      query?: {
        /** @default null */
        teamId?: string;
        /**
         * @format double
         * @default 1
         */
        directoryId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<LaserficheInspectDirectoryItem[] | null, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/inspect/directory`,
        method: "GET",
        funcName: "integrationLaserficheInspectDirectory",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheGetConfigDirectory
     * @request GET:/v1/tenants/{tenantId}/integrations/laserfiche/config/directory
     * @secure
     */
    integrationLaserficheGetConfigDirectory: (
      tenantId: string,
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          orphanSigned?: LaserficheDirectory;
          primary?: LaserficheDirectory;
        } | null,
        any
      >({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/config/directory`,
        method: "GET",
        funcName: "integrationLaserficheGetConfigDirectory",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheConfigDirectory
     * @request PUT:/v1/tenants/{tenantId}/integrations/laserfiche/config/directory
     * @secure
     */
    integrationLaserficheConfigDirectory: (
      tenantId: string,
      data: {
        destinationName: "primary" | "orphanSigned";
        /** @format double */
        directoryId: number;
      },
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/config/directory`,
        method: "PUT",
        funcName: "integrationLaserficheConfigDirectory",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheGetConfigMetadata
     * @request GET:/v1/tenants/{tenantId}/integrations/laserfiche/config/metadata
     * @secure
     */
    integrationLaserficheGetConfigMetadata: (
      tenantId: string,
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Construct a type with a set of properties K of type T */
          documentType?: RecordStringLaserficheMetadata;
          orphanSigned?: LaserficheMetadata;
          signed?: LaserficheMetadata;
          minutes?: LaserficheMetadata;
          documents?: LaserficheMetadata;
          agendas?: LaserficheMetadata;
        } | null,
        any
      >({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/config/metadata`,
        method: "GET",
        funcName: "integrationLaserficheGetConfigMetadata",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheConfigMetadata
     * @request PUT:/v1/tenants/{tenantId}/integrations/laserfiche/config/metadata
     * @secure
     */
    integrationLaserficheConfigMetadata: (
      tenantId: string,
      data: {
        config: LaserfichePutMetadata;
        subType: LaserfichePushType | UploadTypeId;
        type: "basic" | "documentType";
      },
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/config/metadata`,
        method: "PUT",
        funcName: "integrationLaserficheConfigMetadata",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheDeleteConfigMetadata
     * @request DELETE:/v1/tenants/{tenantId}/integrations/laserfiche/config/metadata
     * @secure
     */
    integrationLaserficheDeleteConfigMetadata: (
      tenantId: string,
      query: {
        type: "basic" | "documentType";
        subType: any;
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/config/metadata`,
        method: "DELETE",
        funcName: "integrationLaserficheDeleteConfigMetadata",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheGetInternalConfig
     * @request GET:/v1/tenants/{tenantId}/integrations/laserfiche/config/internal
     * @secure
     */
    integrationLaserficheGetInternalConfig: (
      tenantId: string,
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LaserficheInternalConfiguration | null, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/config/internal`,
        method: "GET",
        funcName: "integrationLaserficheGetInternalConfig",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserficheUpdateInternalConfig
     * @request PUT:/v1/tenants/{tenantId}/integrations/laserfiche/config/internal
     * @secure
     */
    integrationLaserficheUpdateInternalConfig: (
      tenantId: string,
      data: LaserficheInternalConfiguration,
      query?: {
        teamId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/config/internal`,
        method: "PUT",
        funcName: "integrationLaserficheUpdateInternalConfig",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations, private
     * @name IntegrationLaserfichePushMeetingMinutes
     * @request POST:/v1/tenants/{tenantId}/integrations/laserfiche/push/minutes
     * @secure
     */
    integrationLaserfichePushMeetingMinutes: (
      tenantId: string,
      data: {
        documentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          errors?: string;
          success: boolean;
        },
        any
      >({
        path: `/v1/tenants/${tenantId}/integrations/laserfiche/push/minutes`,
        method: "POST",
        funcName: "integrationLaserfichePushMeetingMinutes",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags import, private
     * @name UploadCsvFile
     * @request POST:/v1/tenants/{tenantId}/import/files
     * @secure
     */
    uploadCsvFile: (
      tenantId: string,
      data: ImportDataUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success: boolean;
          headers: string[] | null;
          file: ImportDataUploadResult;
        },
        any
      >({
        path: `/v1/tenants/${tenantId}/import/files`,
        method: "POST",
        funcName: "uploadCsvFile",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags import, private
     * @name CheckForUserImportDuplicates
     * @request POST:/v1/tenants/{tenantId}/import/duplicates
     * @secure
     */
    checkForUserImportDuplicates: (
      tenantId: string,
      data: UserDuplicateCheckConfig,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          duplicates: UserDuplicate[];
        },
        any
      >({
        path: `/v1/tenants/${tenantId}/import/duplicates`,
        method: "POST",
        funcName: "checkForUserImportDuplicates",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags import, private
     * @name ImportUsersFromFile
     * @request POST:/v1/tenants/{tenantId}/import/users
     * @secure
     */
    importUsersFromFile: (
      tenantId: string,
      data: UserImportConfig,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          isPreview: boolean;
          /** @format double */
          totalRecords: number;
          /** @format double */
          importedRecords: number;
          previews?: UserImportData[];
        },
        any
      >({
        path: `/v1/tenants/${tenantId}/import/users`,
        method: "POST",
        funcName: "importUsersFromFile",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get download url for normal or confidential document.
     *
     * @tags documents, private
     * @name DocumentDownloadUrl
     * @request GET:/v1/tenants/{tenantId}/documents/{documentId}/downloadurl
     * @secure
     */
    documentDownloadUrl: (
      tenantId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}/downloadurl`,
        method: "GET",
        funcName: "documentDownloadUrl",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name GetNextLegislationNumber
     * @request POST:/v1/tenants/{tenantId}/documents/legislation-number/{type}/next
     * @secure
     */
    getNextLegislationNumber: (
      tenantId: string,
      type: LegislationNumberType,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/v1/tenants/${tenantId}/documents/legislation-number/${type}/next`,
        method: "POST",
        funcName: "getNextLegislationNumber",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name RevertLegislationNumber
     * @request POST:/v1/tenants/{tenantId}/documents/legislation-number/{type}/revert
     * @secure
     */
    revertLegislationNumber: (
      tenantId: string,
      type: LegislationNumberType,
      data: {
        number: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/documents/legislation-number/${type}/revert`,
        method: "POST",
        funcName: "revertLegislationNumber",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name ListDocuments
     * @request GET:/v1/tenants/{tenantId}/documents
     * @secure
     */
    listDocuments: (tenantId: string, params: RequestParams = {}) =>
      this.request<Document[], any>({
        path: `/v1/tenants/${tenantId}/documents`,
        method: "GET",
        funcName: "listDocuments",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name CreateDocument
     * @request POST:/v1/tenants/{tenantId}/documents
     * @secure
     */
    createDocument: (
      tenantId: string,
      data: CreateDocumentDto,
      params: RequestParams = {},
    ) =>
      this.request<Document, any>({
        path: `/v1/tenants/${tenantId}/documents`,
        method: "POST",
        funcName: "createDocument",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name GetDocument
     * @request GET:/v1/tenants/{tenantId}/documents/{documentId}
     * @secure
     */
    getDocument: (
      tenantId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<Document | null, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}`,
        method: "GET",
        funcName: "getDocument",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name UpdateDocument
     * @request PATCH:/v1/tenants/{tenantId}/documents/{documentId}
     * @secure
     */
    updateDocument: (
      tenantId: string,
      documentId: string,
      data: PatchDocumentDto,
      params: RequestParams = {},
    ) =>
      this.request<Document, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}`,
        method: "PATCH",
        funcName: "updateDocument",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, private
     * @name DeleteDocument
     * @request DELETE:/v1/tenants/{tenantId}/documents/{documentId}
     * @secure
     */
    deleteDocument: (
      tenantId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/documents/${documentId}`,
        method: "DELETE",
        funcName: "deleteDocument",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags config, private
     * @name GetAppConfig
     * @request GET:/v1/config/config
     * @secure
     */
    getAppConfig: (params: RequestParams = {}) =>
      this.request<AppConfig, any>({
        path: `/v1/config/config`,
        method: "GET",
        funcName: "getAppConfig",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags config, private
     * @name GetAgendaItemMetadataConfig
     * @request GET:/v1/config/agendaItemMetadata
     * @secure
     */
    getAgendaItemMetadataConfig: (params: RequestParams = {}) =>
      this.request<AgendaItemMetadataConfig, any>({
        path: `/v1/config/agendaItemMetadata`,
        method: "GET",
        funcName: "getAgendaItemMetadataConfig",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags config, private
     * @name GetExampleFileConfig
     * @request GET:/v1/config/exampleFile
     * @secure
     */
    getExampleFileConfig: (params: RequestParams = {}) =>
      this.request<ExampleFilesConfig, any>({
        path: `/v1/config/exampleFile`,
        method: "GET",
        funcName: "getExampleFileConfig",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags config, private
     * @name GetMeetingTypeConfig
     * @request GET:/v1/config/meetingType
     * @secure
     */
    getMeetingTypeConfig: (params: RequestParams = {}) =>
      this.request<MeetingTypesConfig, any>({
        path: `/v1/config/meetingType`,
        method: "GET",
        funcName: "getMeetingTypeConfig",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags config, private
     * @name GetOrganizationTypesConfig
     * @request GET:/v1/config/organizationTypes
     * @secure
     */
    getOrganizationTypesConfig: (params: RequestParams = {}) =>
      this.request<OrganizationTypesConfig, any>({
        path: `/v1/config/organizationTypes`,
        method: "GET",
        funcName: "getOrganizationTypesConfig",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags config, private
     * @name GetDocumentUploadTypesConfig
     * @request GET:/v1/config/documentUploadTypes
     * @secure
     */
    getDocumentUploadTypesConfig: (params: RequestParams = {}) =>
      this.request<DocumentUploadTypesConfig, any>({
        path: `/v1/config/documentUploadTypes`,
        method: "GET",
        funcName: "getDocumentUploadTypesConfig",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags config, private
     * @name GetMotionTypesConfig
     * @request GET:/v1/config/motionTypes
     * @secure
     */
    getMotionTypesConfig: (params: RequestParams = {}) =>
      this.request<MotionTypesConfig, any>({
        path: `/v1/config/motionTypes`,
        method: "GET",
        funcName: "getMotionTypesConfig",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags config, private
     * @name GetTermsAndConditionsConfig
     * @request GET:/v1/config/termsAndConditions
     * @secure
     */
    getTermsAndConditionsConfig: (params: RequestParams = {}) =>
      this.request<TermsAndConditionsConfig, any>({
        path: `/v1/config/termsAndConditions`,
        method: "GET",
        funcName: "getTermsAndConditionsConfig",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags aiMinutesTemplate, private
     * @name ListAiMinutesTemplates
     * @request GET:/v1/tenants/{tenantId}/aiMinutesTemplate
     * @secure
     */
    listAIMinutesTemplates: (tenantId: string, params: RequestParams = {}) =>
      this.request<AIMinutesTemplate[], any>({
        path: `/v1/tenants/${tenantId}/aiMinutesTemplate`,
        method: "GET",
        funcName: "listAIMinutesTemplates",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags aiMinutesTemplate, private
     * @name CreateAiMinutesTemplate
     * @request POST:/v1/tenants/{tenantId}/aiMinutesTemplate
     * @secure
     */
    createAIMinutesTemplate: (
      tenantId: string,
      data: CreateAIMinutesTemplateDto,
      params: RequestParams = {},
    ) =>
      this.request<AIMinutesTemplate, any>({
        path: `/v1/tenants/${tenantId}/aiMinutesTemplate`,
        method: "POST",
        funcName: "createAIMinutesTemplate",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags aiMinutesTemplate, private
     * @name GetAiMinutesTemplate
     * @request GET:/v1/tenants/{tenantId}/aiMinutesTemplate/{aiMinutesTemplateId}
     * @secure
     */
    getAIMinutesTemplate: (
      tenantId: string,
      aiMinutesTemplateId: string,
      params: RequestParams = {},
    ) =>
      this.request<AIMinutesTemplate | null, any>({
        path: `/v1/tenants/${tenantId}/aiMinutesTemplate/${aiMinutesTemplateId}`,
        method: "GET",
        funcName: "getAIMinutesTemplate",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags aiMinutesTemplate, private
     * @name UpdateAiMinutesTemplate
     * @request PATCH:/v1/tenants/{tenantId}/aiMinutesTemplate/{aiMinutesTemplateId}
     * @secure
     */
    updateAIMinutesTemplate: (
      tenantId: string,
      aiMinutesTemplateId: string,
      data: PatchAIMinutesTemplateDto,
      params: RequestParams = {},
    ) =>
      this.request<AIMinutesTemplate, any>({
        path: `/v1/tenants/${tenantId}/aiMinutesTemplate/${aiMinutesTemplateId}`,
        method: "PATCH",
        funcName: "updateAIMinutesTemplate",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags aiMinutesTemplate, private
     * @name DeleteAiMinutesTemplate
     * @request DELETE:/v1/tenants/{tenantId}/aiMinutesTemplate/{aiMinutesTemplateId}
     * @secure
     */
    deleteAIMinutesTemplate: (
      tenantId: string,
      aiMinutesTemplateId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/aiMinutesTemplate/${aiMinutesTemplateId}`,
        method: "DELETE",
        funcName: "deleteAIMinutesTemplate",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai, private
     * @name GenerateMinutes
     * @request POST:/v1/tenants/{tenantId}/ai/generate-minutes/text
     * @secure
     */
    generateMinutes: (
      tenantId: string,
      data: {
        transcription?: string;
        minutesTemplateId?: string;
        meetingId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          jobId: string;
        } | null,
        any
      >({
        path: `/v1/tenants/${tenantId}/ai/generate-minutes/text`,
        method: "POST",
        funcName: "generateMinutes",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai, private
     * @name GenerateMinutesWithAv
     * @request POST:/v1/tenants/{tenantId}/ai/generate-minutes/av
     * @secure
     */
    generateMinutesWithAV: (
      tenantId: string,
      data: {
        audioFile: AIAVDataDto;
        summarizationLevel: AISummarizationLevel;
        minutesTemplateId?: string;
        meetingId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          jobId: string;
        } | null,
        any
      >({
        path: `/v1/tenants/${tenantId}/ai/generate-minutes/av`,
        method: "POST",
        funcName: "generateMinutesWithAV",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai, private
     * @name GetJobStatus
     * @request GET:/v1/tenants/{tenantId}/ai/job/{jobId}/status
     * @secure
     */
    getJobStatus: (
      tenantId: string,
      jobId: string,
      params: RequestParams = {},
    ) =>
      this.request<AIJobStatusDto | null, any>({
        path: `/v1/tenants/${tenantId}/ai/job/${jobId}/status`,
        method: "GET",
        funcName: "getJobStatus",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai, private
     * @name GetJobResult
     * @request GET:/v1/tenants/{tenantId}/ai/job/{jobId}/download
     * @secure
     */
    getJobResult: (
      tenantId: string,
      jobId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          error?: string;
          minutes?: string;
        } | null,
        any
      >({
        path: `/v1/tenants/${tenantId}/ai/job/${jobId}/download`,
        method: "GET",
        funcName: "getJobResult",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai, private
     * @name DeleteJob
     * @request DELETE:/v1/tenants/{tenantId}/ai/job/{jobId}
     * @secure
     */
    deleteJob: (tenantId: string, jobId: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/ai/job/${jobId}`,
        method: "DELETE",
        funcName: "deleteJob",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendas, private
     * @name ListAgendas
     * @request GET:/v1/tenants/{tenantId}/agendas
     * @secure
     */
    listAgendas: (tenantId: string, params: RequestParams = {}) =>
      this.request<Agenda[], any>({
        path: `/v1/tenants/${tenantId}/agendas`,
        method: "GET",
        funcName: "listAgendas",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendas, private
     * @name CreateAgenda
     * @request POST:/v1/tenants/{tenantId}/agendas
     * @secure
     */
    createAgenda: (
      tenantId: string,
      data: CreateAgendaDto,
      params: RequestParams = {},
    ) =>
      this.request<Agenda, any>({
        path: `/v1/tenants/${tenantId}/agendas`,
        method: "POST",
        funcName: "createAgenda",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendas, private
     * @name GetAgenda
     * @request GET:/v1/tenants/{tenantId}/agendas/{agendaId}
     * @secure
     */
    getAgenda: (
      tenantId: string,
      agendaId: string,
      params: RequestParams = {},
    ) =>
      this.request<Agenda | null, any>({
        path: `/v1/tenants/${tenantId}/agendas/${agendaId}`,
        method: "GET",
        funcName: "getAgenda",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendas, private
     * @name UpdateAgenda
     * @request PATCH:/v1/tenants/{tenantId}/agendas/{agendaId}
     * @secure
     */
    updateAgenda: (
      tenantId: string,
      agendaId: string,
      data: PatchAgendaDto,
      params: RequestParams = {},
    ) =>
      this.request<Agenda, any>({
        path: `/v1/tenants/${tenantId}/agendas/${agendaId}`,
        method: "PATCH",
        funcName: "updateAgenda",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendas, private
     * @name DeleteAgenda
     * @request DELETE:/v1/tenants/{tenantId}/agendas/{agendaId}
     * @secure
     */
    deleteAgenda: (
      tenantId: string,
      agendaId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/agendas/${agendaId}`,
        method: "DELETE",
        funcName: "deleteAgenda",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaModules, private
     * @name ListAgendaModules
     * @request GET:/v1/tenants/{tenantId}/agendaModules
     * @secure
     */
    listAgendaModules: (tenantId: string, params: RequestParams = {}) =>
      this.request<AgendaModule[], any>({
        path: `/v1/tenants/${tenantId}/agendaModules`,
        method: "GET",
        funcName: "listAgendaModules",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaModules, private
     * @name CreateAgendaModule
     * @request POST:/v1/tenants/{tenantId}/agendaModules
     * @secure
     */
    createAgendaModule: (
      tenantId: string,
      data: CreateAgendaModuleDto,
      params: RequestParams = {},
    ) =>
      this.request<AgendaModule, any>({
        path: `/v1/tenants/${tenantId}/agendaModules`,
        method: "POST",
        funcName: "createAgendaModule",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaModules, private
     * @name GetAgendaModule
     * @request GET:/v1/tenants/{tenantId}/agendaModules/{agendaModuleId}
     * @secure
     */
    getAgendaModule: (
      tenantId: string,
      agendaModuleId: string,
      params: RequestParams = {},
    ) =>
      this.request<AgendaModule | null, any>({
        path: `/v1/tenants/${tenantId}/agendaModules/${agendaModuleId}`,
        method: "GET",
        funcName: "getAgendaModule",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaModules, private
     * @name UpdateAgendaModule
     * @request PATCH:/v1/tenants/{tenantId}/agendaModules/{agendaModuleId}
     * @secure
     */
    updateAgendaModule: (
      tenantId: string,
      agendaModuleId: string,
      data: PatchAgendaModuleDto,
      params: RequestParams = {},
    ) =>
      this.request<AgendaModule, any>({
        path: `/v1/tenants/${tenantId}/agendaModules/${agendaModuleId}`,
        method: "PATCH",
        funcName: "updateAgendaModule",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaModules, private
     * @name DeleteAgendaModule
     * @request DELETE:/v1/tenants/{tenantId}/agendaModules/{agendaModuleId}
     * @secure
     */
    deleteAgendaModule: (
      tenantId: string,
      agendaModuleId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/agendaModules/${agendaModuleId}`,
        method: "DELETE",
        funcName: "deleteAgendaModule",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaItems, private
     * @name MailItemApproval
     * @request POST:/v1/tenants/{tenantId}/agendaItems/{agendaItemId}/mail/approval
     * @secure
     */
    mailItemApproval: (
      tenantId: string,
      agendaItemId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/tenants/${tenantId}/agendaItems/${agendaItemId}/mail/approval`,
        method: "POST",
        funcName: "mailItemApproval",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaItems, private
     * @name ListAgendaItems
     * @request GET:/v1/tenants/{tenantId}/agendaItems
     * @secure
     */
    listAgendaItems: (tenantId: string, params: RequestParams = {}) =>
      this.request<AgendaItem[], any>({
        path: `/v1/tenants/${tenantId}/agendaItems`,
        method: "GET",
        funcName: "listAgendaItems",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaItems, private
     * @name CreateAgendaItem
     * @request POST:/v1/tenants/{tenantId}/agendaItems
     * @secure
     */
    createAgendaItem: (
      tenantId: string,
      data: CreateAgendaItemDto,
      params: RequestParams = {},
    ) =>
      this.request<AgendaItem, any>({
        path: `/v1/tenants/${tenantId}/agendaItems`,
        method: "POST",
        funcName: "createAgendaItem",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaItems, private
     * @name GetAgendaItem
     * @request GET:/v1/tenants/{tenantId}/agendaItems/{agendaItemId}
     * @secure
     */
    getAgendaItem: (
      tenantId: string,
      agendaItemId: string,
      params: RequestParams = {},
    ) =>
      this.request<AgendaItem | null, any>({
        path: `/v1/tenants/${tenantId}/agendaItems/${agendaItemId}`,
        method: "GET",
        funcName: "getAgendaItem",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaItems, private
     * @name UpdateAgendaItem
     * @request PATCH:/v1/tenants/{tenantId}/agendaItems/{agendaItemId}
     * @secure
     */
    updateAgendaItem: (
      tenantId: string,
      agendaItemId: string,
      data: PatchAgendaItemDto,
      params: RequestParams = {},
    ) =>
      this.request<AgendaItem, any>({
        path: `/v1/tenants/${tenantId}/agendaItems/${agendaItemId}`,
        method: "PATCH",
        funcName: "updateAgendaItem",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaItems, private
     * @name DeleteAgendaItem
     * @request DELETE:/v1/tenants/{tenantId}/agendaItems/{agendaItemId}
     * @secure
     */
    deleteAgendaItem: (
      tenantId: string,
      agendaItemId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/tenants/${tenantId}/agendaItems/${agendaItemId}`,
        method: "DELETE",
        funcName: "deleteAgendaItem",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agendaItems, private
     * @name GetAgendaItemVersion
     * @request GET:/v1/tenants/{tenantId}/agendaItems/{agendaItemId}/version/{version}
     * @secure
     */
    getAgendaItemVersion: (
      tenantId: string,
      agendaItemId: string,
      version: string,
      params: RequestParams = {},
    ) =>
      this.request<AgendaItem | null, any>({
        path: `/v1/tenants/${tenantId}/agendaItems/${agendaItemId}/version/${version}`,
        method: "GET",
        funcName: "getAgendaItemVersion",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts, private
     * @name GetAccountByEmail
     * @request GET:/v1/accounts/by/email
     * @secure
     */
    getAccountByEmail: (
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Account | null, any>({
        path: `/v1/accounts/by/email`,
        method: "GET",
        funcName: "getAccountByEmail",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts, private
     * @name CreateAuthAccount
     * @request POST:/v1/accounts/auth
     * @secure
     */
    createAuthAccount: (
      data: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/v1/accounts/auth`,
        method: "POST",
        funcName: "createAuthAccount",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts, private
     * @name GetMyAccount
     * @request GET:/v1/accounts/me
     * @secure
     */
    getMyAccount: (params: RequestParams = {}) =>
      this.request<Account | null, any>({
        path: `/v1/accounts/me`,
        method: "GET",
        funcName: "getMyAccount",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts, private
     * @name CreateMyAccount
     * @request POST:/v1/accounts/me
     * @secure
     */
    createMyAccount: (data: CreateAccountDto, params: RequestParams = {}) =>
      this.request<Account | null, any>({
        path: `/v1/accounts/me`,
        method: "POST",
        funcName: "createMyAccount",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags accounts, private
     * @name UpdateMyAccount
     * @request PATCH:/v1/accounts/me
     * @secure
     */
    updateMyAccount: (data: PatchAccountDto, params: RequestParams = {}) =>
      this.request<Account | null, any>({
        path: `/v1/accounts/me`,
        method: "PATCH",
        funcName: "updateMyAccount",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  webhook = {
    /**
     * No description
     *
     * @tags internal, private
     * @name HandleDocusealWebhook
     * @request POST:/webhook/docuseal
     */
    handleDocusealWebhook: (data: any, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/webhook/docuseal`,
        method: "POST",
        funcName: "handleDocusealWebhook",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  scheduled = {
    /**
     * No description
     *
     * @tags scheduled, private
     * @name CheckExpiredAgendaItems
     * @request POST:/scheduled/items/checkExpired
     */
    checkExpiredAgendaItems: (
      data: {
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/scheduled/items/checkExpired`,
        method: "POST",
        funcName: "checkExpiredAgendaItems",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scheduled, private
     * @name CheckExpiredSubmissions
     * @request POST:/scheduled/submissions/checkExpired
     */
    checkExpiredSubmissions: (
      data: {
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/scheduled/submissions/checkExpired`,
        method: "POST",
        funcName: "checkExpiredSubmissions",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scheduled, private
     * @name CheckExpiredTeamMembers
     * @request POST:/scheduled/team/members/checkExpired
     */
    checkExpiredTeamMembers: (
      data: {
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/scheduled/team/members/checkExpired`,
        method: "POST",
        funcName: "checkExpiredTeamMembers",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scheduled, private
     * @name SendMeetingDateNotifications
     * @request POST:/scheduled/meeting/dateNotifications
     */
    sendMeetingDateNotifications: (
      data: {
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/scheduled/meeting/dateNotifications`,
        method: "POST",
        funcName: "sendMeetingDateNotifications",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  internal = {
    /**
     * No description
     *
     * @tags internal, private
     * @name CheckAuth
     * @request GET:/internal/auth
     * @secure
     */
    checkAuth: (params: RequestParams = {}) =>
      this.request<
        {
          auth: {
            email: string;
            tenantIds: string[];
            accountId: string;
            userId: string;
          };
        },
        any
      >({
        path: `/internal/auth`,
        method: "GET",
        funcName: "checkAuth",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
